import { createSlice } from '@reduxjs/toolkit'
import {
  Total,
  ExistingStock,
  AvailableStock,
  StoreName,
  PlaceHolderCol,
  HockB2B,
  Ordered,
  Delivered,
  Unfilled,
  ReturnSupplier,
  HockB2C,
  Purchased,
  Sellout,
  ReturnCustomer,
  WithDrawn,
  InVision,
  Tailoring,
  Transit,
  IsClearArticleInfoAction,
  Inbound,
  Outbound,
  Neutral,
  IsLoadConfigurationAction,
  IsSaveConfigurationAction,
  IsSaveDefaultConfigurationsAction,
  IsDeleteConfigurationAction,
  IsRenameConfigurationAction,
  IsSetActiveStore,
  IsSaveRowKeysAction,
  ExtraRecapRow,
  configurationQuantitiesFilter,
  Exits,
  Entries,
  StockInitial,
  IsLoadProfileOptionsAction,
  ConfigurationForm,
  Stores,
} from '../../Constants/Configuration'
import {
  encryptLocalStorageValue,
  getStorageValue,
  mapWorkspaceQuantitiesFilter,
  removeStorageValue,
  setStorageValue,
} from '../../Helpers/ConfigurationHelper'
import { WorkSpace, WorkSpaces } from '../../Constants/WorkSpace'

//add new filter value on quantitiesFilters and grucciaQuantitiesFilters
const quantitiesFilters = [
  { value: ExistingStock, active: true, status: '', visible: true },
  { value: AvailableStock, active: false, status: '', visible: false },
  { value: StockInitial, active: false, status: Inbound, visible: false },
  { value: HockB2B, active: false, status: Neutral, visible: false },
  { value: Ordered, active: false, status: Neutral, visible: false },
  { value: Delivered, active: false, status: Inbound, visible: false },
  { value: Unfilled, active: false, status: Neutral, visible: false }, //i
  { value: Entries, active: false, status: Inbound, visible: false },
  { value: Transit, active: false, status: Inbound, visible: false },
  { value: Exits, active: false, status: Outbound, visible: false },
  { value: ReturnSupplier, active: false, status: Outbound, visible: false }, //Rf
  { value: HockB2C, active: false, status: Neutral, visible: false },
  { value: Purchased, active: false, status: Outbound, visible: false },
  { value: Sellout, active: false, status: Outbound, visible: false },
  { value: ReturnCustomer, active: false, status: Inbound, visible: false }, //Rc
  { value: WithDrawn, active: false, status: Neutral, visible: false },
  { value: InVision, active: false, status: Neutral, visible: false },
  { value: Tailoring, active: false, status: Neutral, visible: false },
]

const cols = [
  {
    key: StoreName,
  },
  {
    key: PlaceHolderCol,
  },
  {
    key: Total,
  },
  //add distinc sizes array to predefined columns
]

export const quantitiesSlice = createSlice({
  name: 'quantities',
  initialState: {
    value: {
      filters: quantitiesFilters,
      columns: cols,
      enableAllVariant: false,
      unlockHandling: false,
      handledQuantitySelection: [], //{ storeId, variantId, rowKey, columnKey, sizeId, quantity }
      situationFilter: false as Boolean | string,
    },
  },
  reducers: {
    saveFilter: (state, action) => {
      state.value.filters = action.payload
    },
    setEnableAllVariant: (state, action) => {
      state.value.enableAllVariant = !action.payload
      state.value.unlockHandling = false
      if (state.value.handledQuantitySelection.length !== 0) {
        state.value.handledQuantitySelection = []
      }
    },
    setLockedHandling: (state, action) => {
      state.value.unlockHandling = !action.payload
      if (state.value.handledQuantitySelection.length !== 0) {
        state.value.handledQuantitySelection = []
      }

      if (!action.payload) {
        const availableStock = state.value.filters.filter(x => x.value === AvailableStock && x.active)
        if (availableStock.length === 0) {
          const change = state.value.filters.map(x => {
            if (x.value === AvailableStock) {
              x.active = true
            }
            return x
          })

          state.value.filters = change
        }
      }
    },
    setHandledQuantitySelection: (state, action) => {
      if (action.payload && action.payload.length !== 0) {
        const storeId = action.payload[0].storeId

        const filterByStore = state.value.handledQuantitySelection.filter(element => element.storeId === storeId)

        if (filterByStore.length === 0 && state.value.handledQuantitySelection.length !== 0) {
          state.value.handledQuantitySelection = []
        }

        action.payload.forEach(movementationElement => {
          const element = state.value.handledQuantitySelection.filter(
            element =>
              element.storeId === movementationElement.storeId &&
              (element.rowKey === movementationElement.rowKey || element.rowKey === AvailableStock) &&
              element.sizeId === movementationElement.sizeId,
          )
          if (element.length === 0) {
            if (movementationElement.rowKey === ExtraRecapRow) {
              movementationElement.rowKey = AvailableStock
            }
            state.value.handledQuantitySelection.push(movementationElement)
          } else {
            if (movementationElement.rowKey === AvailableStock) {
              element[0].quantity = element[0].quantity + movementationElement.quantity
            } else if (movementationElement.rowKey === ExtraRecapRow) {
              element[0].quantity = movementationElement.quantity
            }
          }
        })
      }
    },
    setHandledTotalQuantitySelection: (state, action) => {
      if (action.payload && action.payload.length !== 0) {
        const storeId = action.payload[0].storeId

        const filterByStore = state.value.handledQuantitySelection.filter(element => element.storeId === storeId)

        if (filterByStore.length === 0 && state.value.handledQuantitySelection.length !== 0) {
          state.value.handledQuantitySelection = []
        }

        const filteredSizeWithoutTotal = action.payload.filter(x => x.columnKey !== Total)

        filteredSizeWithoutTotal.forEach(movementationElement => {
          const element = state.value.handledQuantitySelection.filter(
            element =>
              element.storeId === movementationElement.storeId &&
              element.rowKey === movementationElement.rowKey &&
              element.sizeId === movementationElement.sizeId,
          )
          if (element.length === 0) {
            state.value.handledQuantitySelection.push(movementationElement)
          } else {
            element[0].quantity = movementationElement.quantity
          }
        })
      }
    },
    restoreSelectionAndUpdateQuantities: (state, action) => {
      if (state.value.handledQuantitySelection.length !== 0) {
        state.value.handledQuantitySelection = []
      }
      state.value.unlockHandling = false
    },
    removeHandledQuantitySelection: (state, action) => {
      const filteredValues = state.value.handledQuantitySelection.filter(
        element =>
          action.payload.filter(
            movementationElement =>
              element.storeId === movementationElement.storeId &&
              element.rowKey === movementationElement.rowKey &&
              element.sizeId === movementationElement.sizeId,
          ).length === 0,
      )
      state.value.handledQuantitySelection = [...filteredValues]
    },
    resetHandledQuantitySelection: state => {
      if (state.value.handledQuantitySelection.length !== 0) {
        state.value.handledQuantitySelection = []
      }
      state.value.unlockHandling = false
    },
    setSituationFilter: (state, action) => {
      state.value.situationFilter = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsClearArticleInfoAction, (state, action) => {
        state.value.situationFilter = false
        if (state.value.handledQuantitySelection.length !== 0) {
          state.value.handledQuantitySelection = []
        }
        state.value.enableAllVariant = false

        if (action.payload.formValue === ConfigurationForm.GRUCCIA) {
          state.value.unlockHandling = true
        } else {
          state.value.unlockHandling = false
        }
      })
      .addMatcher(IsLoadConfigurationAction, (state, action) => {
        const isWorkspaceGruccia = action.payload.configurationName === WorkSpace.GRUCCIA
        if (isWorkspaceGruccia) {
          state.value.unlockHandling = true
        }

        const profileOptions = action.payload.defaultProfileOptions ? action.payload.defaultProfileOptions : []
        const mappedFilters = mapWorkspaceQuantitiesFilter(
          action.payload.configurationName,
          profileOptions,
          state.value.filters,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.value.filters = mappedFilters
      })
      .addMatcher(IsLoadProfileOptionsAction, (state, action) => {
        state.value.filters = mapWorkspaceQuantitiesFilter(
          action.payload.configurationName,
          action.payload.defaultProfileOptions,
          quantitiesFilters,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveConfigurationAction, (state, action) => {
        const quantitiesFilterToSave = state.value.filters.filter(x => x.active).map(x => x.value)

        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationQuantitiesFilter,
          JSON.stringify(quantitiesFilterToSave),
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveDefaultConfigurationsAction, (state, action) => {
        if (action.payload.publicWorkspace) {
          const space = WorkSpaces[action.payload.publicWorkspace]
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationQuantitiesFilter,
            JSON.stringify(space[configurationQuantitiesFilter.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
        } else {
          for (const [key, value] of Object.entries(WorkSpaces)) {
            encryptLocalStorageValue(
              key + configurationQuantitiesFilter,
              JSON.stringify(value[configurationQuantitiesFilter.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
          }
        }
      })
      .addMatcher(IsDeleteConfigurationAction, (state, action) => {
        removeStorageValue(
          action.payload.configurationName + configurationQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsRenameConfigurationAction, (state, action) => {
        const oldFilters = getStorageValue(
          action.payload.before + configurationQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
        )

        setStorageValue(
          action.payload.after + configurationQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
          oldFilters,
        )

        removeStorageValue(
          action.payload.before + configurationQuantitiesFilter,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSetActiveStore, (state, action) => {
        if (state.value.situationFilter !== Stores.Remote) {
          state.value.situationFilter = false
        }
      })
      .addMatcher(IsSaveRowKeysAction, (state, action) => {
        state.value.situationFilter = false
        if (state.value.handledQuantitySelection.length !== 0) {
          state.value.handledQuantitySelection = []
        }
        state.value.enableAllVariant = false

        if (action.payload.formValue === ConfigurationForm.GRUCCIA) {
          state.value.unlockHandling = true
        } else {
          state.value.unlockHandling = false
        }
      })
      // and provide a default case if no other handlers matched
      .addDefaultCase((state, action) => {})
  },
})

export const {
  saveFilter,
  setEnableAllVariant,
  setLockedHandling,
  setHandledQuantitySelection,
  removeHandledQuantitySelection,
  resetHandledQuantitySelection,
  restoreSelectionAndUpdateQuantities,
  setSituationFilter,
  setHandledTotalQuantitySelection,
} = quantitiesSlice.actions

export default quantitiesSlice.reducer
